module.exports = __webpack_public_path__ + "img/mobile-screenshots-update.adf9ad3a.webp";